import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { getTestLabels } from '../../../utils/getTestLabels.js';
import style from '../style/labelAndLegend.module.scss.js';

const { componentTestLabel } = getTestLabels('Legend');
/**
 * [source code](https://src.private.zooplus.net/projects/FE/repos/ui-components/browse/src/components/Form/Fieldset/Legend.tsx)
 
 * An HTML `legend` element for use inside of HTML `fieldset` elements (or the `Fieldset` ui-component).
 *
 * Note that the content passed as children should only be valid phrasing content or headings (h1-h6)
 * (see [MDN legend docs](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/legend)).
 *
 * @param {string} legendPosition - (optional) One of `normal` (default) or `side`. Controls the legend's text-align
 * @param {ReactChild} children - (optional, but silly without it) Can be any ReactNode/HTML element, but permitted content of a `legend` **should** only be phrasing content or headings (h1-h6) (see [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/legend))
 * @param {boolean} isRequired - (optional) **DEPRECATED Will be removed in a future version.
 *   Use `optionalText` when the field is optional instead of `isRequired` when the field is required.**.
 *   When set to `true`, a red asterisk (`*`) is displayed after the label text.
 * @param {string} optionalText - (optional) Text to show if filling in the associated field(s) is optional.
 */
const Legend = forwardRef((props, ref) => {
    const { children, className, isRequired, legendPosition = 'normal', optionalText, ...otherProps } = props;
    return (jsxs("legend", { "data-zta": componentTestLabel, ref: ref, ...otherProps, className: classNames(style['z-legend'], {
            [style['z-legend--required']]: isRequired && !optionalText,
            [style['z-legend--side']]: legendPosition === 'side',
        }, className), children: [children, ' ', optionalText && (jsx("span", { className: style['z-label__optional'], children: optionalText }))] }));
});
Legend.displayName = 'Legend';

export { Legend };
//# sourceMappingURL=Legend.js.map
